import { render, staticRenderFns } from "./ListRolePage.vue?vue&type=template&id=164a75de&scoped=true&"
import script from "./ListRolePage.vue?vue&type=script&lang=js&"
export * from "./ListRolePage.vue?vue&type=script&lang=js&"
import style0 from "./ListRolePage.vue?vue&type=style&index=0&id=164a75de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a75de",
  null
  
)

export default component.exports